import { Link } from '@tanstack/react-router'
import { Flame } from 'lucide-react'
import { useMobilePageTitle } from './shell/mobile-shell-outlets'
import { Button } from './ui/button'

/**
 * Gestaltete deutsche 404-Seite (Text-Audit B7) — ersetzt das ungestylte
 * englische „Not Found" von TanStack Router. Wird in router.ts als
 * defaultNotFoundComponent registriert und rendert innerhalb der App-Shell.
 */
export function NotFound() {
  // Shell-Top-Titel <640 — sonst bleibt die Leiste auf 404-Routen leer.
  useMobilePageTitle('Seite nicht gefunden')
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent/10">
        <Flame className="h-7 w-7 text-accent/70" aria-hidden="true" />
      </div>
      <p className="font-mono text-5xl font-light tracking-tight text-text-tertiary tabular-nums">
        404
      </p>
      <div className="space-y-1">
        <h1 className="font-serif text-2xl tracking-tight text-text-primary">
          Seite nicht gefunden
        </h1>
        <p className="text-sm text-text-tertiary">
          Diese Adresse existiert nicht (mehr) — vielleicht ein alter Link oder ein Tippfehler.
        </p>
      </div>
      <Button asChild className="mt-2">
        <Link to="/">Zurück zum Dashboard</Link>
      </Button>
    </div>
  )
}
